import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // Individual scroll functions for each navigation link
    const scrollToFeatures = (e) => {
        e.preventDefault();
        setIsMobileMenuOpen(false); // Close mobile menu
        const featuresSection = document.getElementById("features");
        if (featuresSection) {
            const header = document.querySelector(".header");
            const headerHeight = header.offsetHeight - 120; // adjusted for reduced header padding
            const elementPosition = featuresSection.offsetTop;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    const scrollToContact = (e) => {
        e.preventDefault();
        setIsMobileMenuOpen(false); // Close mobile menu
        const contactSection = document.getElementById("contact");
        if (contactSection) {
            const header = document.querySelector(".header");
            const headerHeight = header.offsetHeight - 108; // adjusted for reduced header padding
            const elementPosition = contactSection.offsetTop;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth",
            });
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <header className={`header ${isScrolled ? "scrolled" : ""}`}>
            <div className="container">
                <div className="header-content">
                    <div className="logo">
                        <button
                            onClick={scrollToTop}
                            className="logo-button">
                            <img
                                src="/stamp-med-blue.png"
                                alt="Stamp Medical"
                            />
                        </button>
                    </div>

                    <nav className={`nav ${isMobileMenuOpen ? "nav-open" : ""}`}>
                        <ul className="nav-list">
                            <li>
                                <a
                                    href="#features"
                                    onClick={scrollToFeatures}>
                                    Benefits
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    onClick={scrollToContact}>
                                    Join Now
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <div className="header-actions">
                        <button
                            className="btn btn-secondary"
                            onClick={scrollToContact}>
                            Get Started
                        </button>
                        <button
                            className="mobile-menu-toggle"
                            onClick={toggleMobileMenu}
                            aria-label="Toggle mobile menu">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
